<template>
    <div>
        <div class="list all-center" v-if="ctype !== 2">
            <div class="content-item">
                <div class="header -one">累计竞拍{{ ctypeName }}</div>
                <div class="content -one">
                    <div class="label" v-if="false">金额：</div>
                    <div class="number">
                        {{ info.auctionTotalAmount
                        }}<span class="unit">{{
                            !siteId ? '亿元' : '万元'
                        }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label" v-if="false">笔数：</div>
                    <div class="number">
                        {{ $toTnteger(info.auctionTotalNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div class="content-item -two">
                <div class="header -two">累计协议{{ ctypeName }}</div>
                <div class="content -one">
                    <div class="label" v-if="false">金额：</div>
                    <div class="number">
                        {{ info.agreementTotalAmount
                        }}<span class="unit">{{
                            !siteId ? '亿元' : '万元'
                        }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label" v-if="false">笔数：</div>
                    <div class="number">
                        {{ $toTnteger(info.agreementTotalNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div class="content-item -two">
                <div class="header -three">累计备案{{ ctypeName }}</div>
                <div class="content -one">
                    <div class="label" v-if="false">金额：</div>
                    <div class="number">
                        {{ info.historyTotalAmount
                        }}<span class="unit">{{
                            !siteId ? '亿元' : '万元'
                        }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label" v-if="false">笔数：</div>
                    <div class="number">
                        {{ $toTnteger(info.historyTotalNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div class="content-item -two">
                <div class="header -four">累计总{{ ctypeName }}</div>
                <div class="content -one">
                    <div class="label" v-if="false">金额：</div>
                    <div class="number">
                        {{ info.totalAmount
                        }}<span class="unit">{{
                            !siteId ? '亿元' : '万元'
                        }}</span>
                    </div>
                </div>
                <div class="content">
                    <div class="label" v-if="false">笔数：</div>
                    <div class="number">
                        {{ $toTnteger(info.totalNumber) || 0
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="list all-center" v-else>
            <div
                class="content-item"
                :class="[
                    info.siteBigScreenTotalArea
                        ? '_content-item-three'
                        : '_content-item-two'
                ]"
            >
                <div class="header -one">挂牌面积</div>
                <div class="content -one">
                    <div class="number">
                        {{ totalArea }}<span class="unit">亩</span>
                    </div>
                </div>
            </div>
            <div
                class="content-item -two"
                :class="[
                    info.siteBigScreenTotalArea
                        ? '_content-item-three'
                        : '_content-item-two'
                ]"
            >
                <div class="header -two">挂牌数量</div>
                <div class="content -one">
                    <div class="number">
                        {{ !siteId ? '238213' : info.totalNumber
                        }}<span class="unit">笔</span>
                    </div>
                </div>
            </div>
            <div
                class="content-item -two"
                :class="[
                    info.siteBigScreenTotalArea
                        ? '_content-item-three'
                        : '_content-item-two'
                ]"
                v-if="info.siteBigScreenTotalArea"
            >
                <div class="header -four">总面积</div>
                <div class="content -one">
                    <div class="number">
                        {{ info.siteBigScreenTotalArea
                        }}<span class="unit">亩</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as screenAPI from '@/api/screen'
import eventHub from '@/utils/eventHub'

/**
 * 交易情况
 */
export default {
    data() {
        return {
            siteId: 0,
            info: {
                agreementTotalAmount: '0.0', // 累计协议成交金额
                agreementTotalNumber: 0, // 累计协议成交笔数

                auctionTotalAmount: '0.0', // 累计竞拍成交金额
                auctionTotalNumber: 0, // 累计竞拍成交笔数

                historyTotalAmount: '0.0', // 累计备案交易金额
                historyTotalNumber: 0, // 累计备案交易笔数

                totalAmount: '0.0', // 累计总成交金额
                totalNumber: 0, // 累计总成交笔数
                moneyUnit: '' // 交易单位
            },
            ctype: 1,
            ctypeName: '成交',
            totalArea: 0
        }
    },
    methods: {
        async getTotalSummary() {
            this.info = {
                agreementTotalAmount: '0.0', // 累计协议成交金额
                agreementTotalNumber: 0, // 累计协议成交笔数

                auctionTotalAmount: '0.0', // 累计竞拍成交金额
                auctionTotalNumber: 0, // 累计竞拍成交笔数

                historyTotalAmount: '0.0', // 累计备案交易金额
                historyTotalNumber: 0, // 累计备案交易笔数

                totalAmount: '0.0', // 累计总成交金额
                totalNumber: 0, // 累计总成交笔数
                moneyUnit: '' // 交易单位
            }

            const params = {
                resource: this.$route.name === 'haiken' ? 2 : undefined,
                siteId: this.siteId,
                locId: this.$getLocId(),
                summaryType: this.ctype //统计类型 1交易 2挂牌
            }
            const response = await screenAPI.getTotalSummary(params)
            this.info = response.data
        },
        isNull(str) {
            return Number(str) ? Number(str) : 0
        }
    },
    mounted() {
        this.siteId =
            this.$route.params.id === 'zhongguo' ? 0 : this.$route.params.id

        eventHub.$on('tradeChange', (data) => {
            if (this.$route.name === 'haiken') {
                this.totalArea = this.isNull(data.area.gytdcbjyq).toFixed(2)
            } else {
                if (!this.siteId) {
                    this.totalArea = '231122126.10'
                } else {
                    this.totalArea = (
                        this.isNull(data.area.tdjyq) +
                        this.isNull(data.area.jtzyxzc) +
                        this.isNull(data.area.lq) +
                        this.isNull(data.area.jtjyxjsyd)
                    ).toFixed(2)
                }
            }
        })
        eventHub.$on('areaChange', (data) => {
            if (data && data.ctype) {
                this.ctype = data.ctype
                this.ctypeName = data.ctype === 1 ? '成交' : '挂牌'
            }
            this.getTotalSummary()
        })
    }
}
</script>

<style lang="scss" scoped>
.list {
    margin: 20px auto 0;
    padding: 0 10px;
    width: calc(100% - 20px);
    display: flex;
    justify-content: space-between;
}
.content-line {
    width: 1px;
    background: #fff;
    height: 80px;
}
._content-item-two {
    padding: 25px 40px 10px 100px !important;
}
._content-item-three {
    padding: 25px 40px 10px 50px !important;
}
.content-item {
    position: relative;
    flex: 1;
    &.-two {
        margin-left: 4px;
        padding-left: 18px;
        box-sizing: border-box;
        &::after {
            content: '';
            position: absolute;
            height: 80px;
            top: 20px;
            width: 1px;
            background-color: #495f78;
        }
        &::after {
            left: 0;
        }
        &::before {
            right: 0;
        }
    }
    > .header {
        height: 29px;
        background-position: left top;
        background-repeat: no-repeat;
        background-size: 25px 25px;
        padding-left: 30px;
        font-size: 15.49px;
        color: #ffffff;
        letter-spacing: 0.12px;
        line-height: 26px;
        margin-bottom: 10px;
        white-space: nowrap;
        &.-one {
            background-image: url('../../../assets/images/auction.png');
        }
        &.-two {
            background-image: url('../../../assets/images/agreement.png');
        }
        &.-three {
            background-image: url('../../../assets/images/history.png');
        }
        &.-four {
            background-image: url('../../../assets/images/total.png');
        }
    }
    > .content {
        line-height: 28px;
        display: flex;
        align-items: center;
        &.-one {
            margin-bottom: 4px;
        }
        > .label {
            font-size: 16px;
            color: #fff;
            line-height: 28px;
            flex-shrink: 0;
        }
        > .number {
            margin-left: 3px;
            font-size: 18px;
            color: #ffa106;
            letter-spacing: 0.08px;
            font-weight: 600;
            font-family: PingFangSC-Semibold;
            white-space: nowrap;
            > .unit {
                font-family: PingFangSC-Regular;
                letter-spacing: 0;
                font-size: 14px;
                font-weight: normal;
                margin-left: 2px;
                vertical-align: baseline;
            }
        }
    }
}
</style>
